var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "FeedbackMessage", class: _vm.cardClasses },
    [
      _c(
        "carousel",
        {
          attrs: {
            perPage: _vm.perPage,
            navigationEnabled: _vm.navigationEnabled,
            navigationNextLabel: _vm.navigationNextLabel,
            navigationPrevLabel: _vm.navigationPrevLabel,
            paginationEnabled: _vm.paginationEnabled,
            paginationColor: _vm.paginationColor,
            paginationActiveColor: _vm.paginationActiveColor,
            autoplay: _vm.autoplay,
            autoplayTimeout: _vm.autoplayTimeout,
            autoplayHoverPause: _vm.autoplayHoverPause,
            loop: _vm.loop,
            speed: _vm.speed,
            easing: _vm.easing
          }
        },
        _vm._l(_vm.dataListMapped, function(feedback) {
          return _c("slide", { key: feedback.id }, [
            _c("div", { staticClass: "feedback-card" }, [
              _c("img", {
                staticClass: "feedback-card-image",
                attrs: { src: _vm.iconSrc }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "feedback-user" }, [
                _c("img", {
                  staticClass: "feedback-user-image",
                  attrs: { src: feedback.imageSrc }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "feedback-card-title" }, [
                _vm._v(_vm._s(feedback.title))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "feedback-card-message" }, [
                _vm._v(_vm._s(feedback.message))
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "feedback-user" }, [
                _c("div", [
                  _c("p", { staticClass: "feedback-user-name" }, [
                    _vm._v(_vm._s(feedback.username))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "feedback-user-title" }, [
                    _vm._v(_vm._s(feedback.role))
                  ])
                ])
              ])
            ])
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }